import { render, staticRenderFns } from "./page-create-affirmation.vue?vue&type=template&id=0973a827&"
import script from "./page-create-affirmation.vue?vue&type=script&lang=ts&"
export * from "./page-create-affirmation.vue?vue&type=script&lang=ts&"
import style0 from "./page-create-affirmation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports